import { render, staticRenderFns } from "./model.vue?vue&type=template&id=73089a2c&scoped=true"
import script from "./model.vue?vue&type=script&lang=ts"
export * from "./model.vue?vue&type=script&lang=ts"
import style0 from "./model.vue?vue&type=style&index=0&id=73089a2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73089a2c",
  null
  
)

export default component.exports